import { gql } from 'graphql-tag';

export const GET_SUPPLIER_ACCOUNTS = gql`
  query Id5accb89365e12a08b598c2c9bd3731ae(
    $companyId: ID!
    $filter: AccountPayableFilter
  ) {
    __typename
  }
`;
